import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ModalDeleteItem from '../../Modal-Delete-Item';
import Activity from './Activity';
import { Kanban } from 'libs/kanban';
import styled from 'styled-components';

const TabPaneActivities = ({ setStatus, activities, setActivities }) => {
  const { t: translate } = useTranslation();
  const { search } = window.location;
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  const toggleModal = () => {
    const willClose = isOpenModalDelete;
    setIsOpenModalDelete(!isOpenModalDelete);

    if (willClose) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const deleteActivity = async () => {
    return seo.deleteTypeItem('activities', selectedActivity.id);
  };

  return (
    <TabPaneStyles>
      <span>{translate('Activities')}</span>
      <div className="d-flex flex-column gap-2">
        {(Array.isArray(activities) ? activities.filter(Boolean) : []).map((activity) => (
          <Activity
            key={activity?.id}
            id={activity?.id}
            name={activity?.name}
            setItems={setActivities}
            index={activities.filter(Boolean).findIndex((col) => col.id === activity.id)}
            total={activities.filter(Boolean).length}
            isNew={activity.isNew}
            setSelectedItem={setSelectedActivity}
            setIsOpenModalDelete={setIsOpenModalDelete}
            setStatus={setStatus}
          />
        ))}
        <Button
          color="outline"
          style={{ width: '37.5rem' }}
          onClick={() => {
            if (!Array.isArray(activities)) {
              setActivities([{ id: 'temp-1', name: '', isNew: true }]);
            } else {
              setActivities([
                ...activities.filter(Boolean),
                { id: `temp-${activities.filter(Boolean).length + 1}`, name: '', isNew: true },
              ]);
            }
          }}
        >
          <i className="bx bx-plus" />
          {translate('Add activity')}
        </Button>
      </div>
      <ModalDeleteItem
        isOpen={isOpenModalDelete}
        toggle={toggleModal}
        item={selectedActivity}
        setItems={setActivities}
        setStatus={setStatus}
        onDelete={deleteActivity}
        headerText="Delete activity"
        bodyText="Are you sure you want to delete the activity {{item}}?"
      />
    </TabPaneStyles>
  );
};

const TabPaneStyles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  flex: 1 0 0;

  span {
    color: #343a40;
    font-size: 1.01563rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

TabPaneActivities.propTypes = {
  setStatus: PropTypes.func.isRequired,
  activities: PropTypes.array.isRequired,
  setActivities: PropTypes.func.isRequired,
};

export default TabPaneActivities;
